import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { CustomLabelWithToolTip } from 'Components/CustomLabel/Index'
import { useLocation, useNavigate, useParams } from 'react-router'
import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { CAREGIVER_PORTAL_DASHBOARD } from 'Pages/Routes'
import { useScrollTop } from 'hooks/use-scrollTop'
import { CareManagementSummary } from 'Components/CareManagement/CareManagementSummary'

interface CareMgmtData {
  childName: string
  childId: number
}
export function CaregiverPostSubmit (): JSX.Element {
  const { isdId } = useParams()
  const nav = useNavigate()
  const location = useLocation()
  const careManagements: CareMgmtData[] = location.state?.careManagements?.careManagementAssignments
  useScrollTop()
  const [canShowCareManagement, setCanShowCareManagement] = useState(false)

  const loadData = async (): Promise<void> => {
    const { response: isdRsp } = await sendGet(`/CaregiverPortal/CanShowCareManagement?isdid=${isdId ?? ''}`, {})
    if (isdRsp != null) {
      setCanShowCareManagement(isdRsp)
    }
  }

  useEffect(() => {
    void loadData()
  }, [])

  const goToProfile = (): void => {
    nav(CAREGIVER_PORTAL_DASHBOARD)
  }

  return <Container>
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ mt: '20px' }}>
        <Typography variant='h5' sx={{ fontWeight: 600 }} component='div'>
          Thank you! Your interest form has been submitted.
        </Typography>
        <Typography variant='body1' component='div' sx={{ mt: '20px' }}>
          An interest form has been successfully submitted. It will be evaluated by a coordinator and they will reach out.
        </Typography>
        {canShowCareManagement && careManagements?.length > 0 && (<Box>
          <Box>Care Managements Added</Box>
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
            <CareManagementSummary childID={careManagements[0].childId} childName={careManagements[0].childName} />
          </Box>
        </Box>)}
        <Typography variant='h6' component='div' sx={{ mt: '20px' }}>
          What do I do next?
        </Typography>
        <Typography variant='body1' component='div' sx={{ mt: '10px' }}>
          <CustomLabelWithToolTip
            name='IF_Post_Submit_Greeting'
            isdId={isdId ?? 0}
            insertNewLines={true}
            defaultLabelText={`While you wait to hear back, you can complete the rest of your MiECC profile by adding additional dependents, other guardians who can act on their behalf, or any missing information and documentation not included in this interest form.

            Having an up-to-date profile can help us identify missing services or resources that you may find helpful in the future.

            Thank you again!`}
          />
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ mt: '30px' }}>
        <Button
          name='profileButton'
          className='footer-button'
          data-testid='profile-button'
          onClick={goToProfile}
          variant='contained'
        >
          Go to Profile
        </Button>
      </Grid>
    </Grid>
  </Container>
}
